import React from "react";
import { Tooltip } from "antd";
import {MESSAGES, PlanId, SubscriptionOption} from "../utils/silverplus.constants.ts";
import {formatDate} from "../utils/silverplus.utils.ts";
import {SilverButton} from "../../../components/LayoutWrapperCandidate.tsx";

export const PricingCardButton: React.FC<{
    option: SubscriptionOption;
    isCurrentPlan: boolean;
    isUpgrade: boolean;
    isPending: boolean;
    isLoading: boolean;
    userPlanEndDate?: number;
    currentPlanId: PlanId;
    onClick: () => void;
}> = ({ option, isCurrentPlan, isUpgrade, isPending, isLoading, userPlanEndDate, currentPlanId, onClick }) => {
    const getButtonText = (): string => {
        if (isCurrentPlan) return MESSAGES.buttons.currentPlan;
        if (option.id === '0' && currentPlanId !== '0') return MESSAGES.buttons.switchToFree;
        if (!isUpgrade && !isCurrentPlan && option.id !== '0') return MESSAGES.buttons.notAvailable;
        return MESSAGES.buttons.proceedToPayment;
    };

    const isDisabled = isCurrentPlan || isPending ||
        (option.id === '0' && currentPlanId !== '0') ||
        (!isUpgrade && !isCurrentPlan && option.id !== '0');

    const getTooltipTitle = (): string => {
        if (option.id === '0' && currentPlanId !== '0' && userPlanEndDate) {
            return MESSAGES.tooltips.downgradeTiming(formatDate(userPlanEndDate));
        }
        if (!isCurrentPlan && !isUpgrade && option.id !== '0') {
            return MESSAGES.tooltips.downgradeRestriction;
        }
        return '';
    };

    return (
        <Tooltip title={getTooltipTitle()} placement="top">
            <SilverButton
                style={{marginBottom: 16}}
                type="primary"
                size="large"
                disabled={isDisabled}
                loading={isLoading}
                onClick={(e) => {
                    e.preventDefault();
                    if (!isCurrentPlan && option.planKey && !isPending && isUpgrade) {
                        onClick();
                    }
                }}
            >
                {getButtonText()}
            </SilverButton>
        </Tooltip>
    );
};
